import TrezorMiniIcon from './TrezorMiniIcon'

export default TrezorMiniIcon
